import * as React from 'react';
import { SVGProps } from 'react';

const SvgPhoneOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="M15.848 10.05c.307.637.463 1.315.463 2.016a.687.687 0 1 0 1.375 0c0-.912-.202-1.792-.6-2.612a5.98 5.98 0 0 0-2.224-2.475 6.059 6.059 0 0 0-3.103-.913.687.687 0 1 0-.018 1.376 4.598 4.598 0 0 1 4.107 2.608Z"
      fill="currentColor"
    />
    <path
      d="M19.835 8.115A9.061 9.061 0 0 0 11.749 3h-.004a.689.689 0 0 0-.005 1.375 7.648 7.648 0 0 1 6.857 4.336 7.584 7.584 0 0 1 .77 3.346.687.687 0 1 0 1.376 0 8.965 8.965 0 0 0-.908-3.942ZM17.52 15.248a1.294 1.294 0 0 0-1.673-.188l-1.462.94c-.294-.124-1.288-.675-3.507-3.058-2.237-2.397-2.709-3.415-2.81-3.708L9.11 7.84a1.294 1.294 0 0 0-.069-1.682L6.762 3.72a1.328 1.328 0 0 0-.98-.427c-.409 0-.785.18-1.041.495l-.633.78c-.568.673-.857 1.503-.848 2.475.005.852.239 1.815.697 2.865.765 1.764 2.19 3.809 4.01 5.757.959 1.026 2.462 2.489 4.195 3.648C13.835 20.432 15.329 21 16.603 21c.83 0 1.559-.243 2.173-.72l.82-.577c.317-.225.523-.573.564-.958a1.335 1.335 0 0 0-.353-1.054l-2.287-2.443Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPhoneOutlined;
